export default "__VITE_ASSET__uSdCJchu__"